import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { captureReferralCode } from '@/features/referrals/referral-code';
import { getPlatform } from '@/platform/platform';

import { App } from './app/App.tsx';
/*
 * Шрифты брендбука из собственного бандла, не с внешнего CDN (CSP).
 * Cormorant — Light 300 (заголовки) и Medium 500, только нужные наборы символов.
 */
import '@fontsource-variable/inter';
import '@fontsource/cormorant-garamond/latin-300.css';
import '@fontsource/cormorant-garamond/cyrillic-300.css';
import '@fontsource/cormorant-garamond/latin-500.css';
import '@fontsource/cormorant-garamond/cyrillic-500.css';
import './index.css';

/*
 * Код приглашения снимается с адреса до отрисовки: маршрутизатор может
 * переписать адрес раньше, чем любой экран успеет его прочитать, а сам
 * код нужен позже — при первом обращении к серверу.
 */
captureReferralCode(window.location.href);

/*
 * Telegram передаёт startapp-параметр отдельно от query string ссылки
 * (initDataUnsafe.start_param), а не как `?ref=` — приводим его к тому же
 * каналу, которым уже пользуется captureReferralCode. Вызов безвреден,
 * если код уже был снят с URL: captureReferralCode не перезаписывает
 * сохранённое значение.
 */
const startParam = getPlatform().getStartParam();

if (startParam) {
  captureReferralCode(`${window.location.origin}?ref=${encodeURIComponent(startParam)}`);
}

const container = document.getElementById('root');

if (!container) {
  throw new Error('Не найден корневой элемент #root');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
